import { styled } from '@mui/system'

export const EmptyStateWrapper = styled('div')`
    margin-top: 24px;
`
